import { Component, OnInit, ViewChild } from '@angular/core';
import { InputTextModule } from 'primeng/inputtext';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CalendarModule } from 'primeng/calendar';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StrategyService } from '../../../services/strategy.service';
import { Strategy } from '../../../interfaces/models/strategy.model';
import { ActivatedRoute, Router, RouterLink, RouterModule } from '@angular/router';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { CommonModule, DatePipe } from '@angular/common';
import { DateRangeValidatorDirective } from '../../../directives/date-range.directive';
import { TranslateModule } from '@ngx-translate/core';
import { DirectionService } from '../../../services/direction.service';
import { filter, switchMap } from 'rxjs';
@Component({
  selector: 'app-create-strategy',
  standalone: true,
  imports: [
    RouterLink,
    RouterModule,
    CommonModule,
    InputTextareaModule,
    InputTextModule,
    RadioButtonModule,
    CalendarModule,
    FormsModule,
    ReactiveFormsModule,
    DateRangeValidatorDirective,
    TranslateModule
  ],
  templateUrl: './create-strategy.component.html',
  styleUrl: './create-strategy.component.scss',
  providers: [DatePipe]
})
export class CreateStrategyComponent implements OnInit {
  @ViewChild('strategyForm') strategyForm !: FormGroup;
  @ViewChild('dateForm') dateForm!: FormGroup;
  defualtStrategy = {} as Strategy;
  is_default: boolean | undefined;

  strategyFormData = {
    name: '',
    name_en: '',
    vision: '',
    mission: '',
    start_date: null,
    end_date: null,
    is_default: false
  } as any
  dir!: 'rtl' | 'ltr';
  isSubmit = false;
  strategyId = 0
  constructor(private StrategyService: StrategyService,
    private router: Router,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private directionService: DirectionService

  ) {
  }

  ngOnInit(): void {
    this.StrategyService.defaultStrategy$.subscribe(strategy => {
      this.defualtStrategy = strategy as Strategy;
    })


    this.route.paramMap.pipe(filter(params => {
      const id = parseInt(params.get('id') ?? '0');
      return !isNaN(id) && id > 0;
    })
      , switchMap((params: any) => {
        this.strategyId = +params.get('id');
        return this.StrategyService.getStrategyById(this.strategyId)
      })).subscribe((strategy: any) => {
        const { is_default, name, vision, start_date, end_date, mission } = strategy['data']['strategy'];
        this.is_default = is_default;
        this.strategyFormData = { is_default, name, vision, start_date: new Date(start_date), end_date: new Date(end_date), mission }
      })

    this.directionService.direction$.subscribe((dir) => {
      this.dir = dir;
    })

  }
  submit() {

    // this.datePipe.transform(new Date(end_date), 'MM/dd/yyyy')

    const dateFormatter = new Intl.DateTimeFormat('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric'
    })
    // Extract parts of the formatted date
    let end_date = dateFormatter.format(this.dateForm.value.end_date);
    let start_date = dateFormatter.format(this.dateForm.value.start_date);
    this.isSubmit = true;




    if (this.strategyId && this.strategyId != 0) {
      this.StrategyService.updateStrategy({ ...this.strategyForm.value, end_date, start_date, id: this.strategyId }).subscribe(response => {
        this.router.navigate([`/strategicPillar/${this.strategyId}`])
      })
    } else {
      this.StrategyService.createStrategy({ ...this.strategyForm.value, end_date, start_date }).subscribe(((response: any) => {
        this.strategyForm.reset({});
        this.router.navigate([`/strategicPillar/${response?.id}`], { state: this.strategyFormData.name })
      }))
    }


  }
}
